import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToastService} from '../toast-service';
import {CommonCrudService} from "../common/common-crud.service";
import {OrderReferencePattern} from "../../model/mapping/order-reference-pattern";
import {CrystalclearMappingBackUrl} from "../config/crystalclear-mapping-back-url";

@Injectable({
  providedIn: 'root'
})
export class MappingOrderReferencePatternService extends CommonCrudService<OrderReferencePattern> {

  constructor(http: HttpClient,
              toastService: ToastService) {
    super(http,
      toastService,
      CrystalclearMappingBackUrl.GET_MAPPING_ORDERREFERENCEPATTERN_LIST,
      CrystalclearMappingBackUrl.SAVE_MAPPING_ORDERREFERENCEPATTERN,
      CrystalclearMappingBackUrl.DELETE_MAPPING_ORDERREFERENCEPATTERN);
  }

}
